import { NoSsr } from "@mui/base";
import React from "react";

import { DynamicDeviceFrameset } from "./dynamics";
import {
  Container,
  DeviceContainer,
  Hint,
  HintContainer,
  StyledIframe,
  SwipeDown,
  SwipeUp,
} from "./styles";

export type Props = {
  sourceUrl?: string;
} & React.DetailsHTMLAttributes<HTMLDivElement>;

export const NewsletterPreview: React.FunctionComponent<Props> = ({ sourceUrl, ...props }) => (
  <Container {...props}>
    <DeviceContainer>
      <NoSsr>
        <DynamicDeviceFrameset color="midnight" device="iphone-14">
          <StyledIframe src={sourceUrl ?? ""} />
        </DynamicDeviceFrameset>
      </NoSsr>
    </DeviceContainer>
    <HintContainer>
      <SwipeUp />
      <Hint>Scroll to Preview</Hint>
      <SwipeDown />
    </HintContainer>
  </Container>
);

NewsletterPreview.displayName = "NewsletterPreview";
